import logo from "../../Assets/logo.png";
import img1 from "../../Assets/facilities/01 (1).jpg"
import img2 from "../../Assets/facilities/02.jpg"
import img3 from "../../Assets/facilities/03 (1).jpg"
import img4 from "../../Assets/facilities/04 (1).jpg"

export const FacilitiesData = [
  {
    id: 1,
    logo,
    title: "Life Skills Studio",
    subtitle: "Building Confidence for Everyday Life",
    image: img1,
    color: "#0D66B2",
    points: [
      "Independence",
      "Communication",
      "Self-care",
      "Teamwork",
      "Social Awareness",
    ],
    description:
      "Children develop essential life skills, self-confidence, and social skills through hands-on experiences and guided activities.",
  },
  {
    id: 2,
    logo,
    title: "Math Magic Zone",
    subtitle: "Making Numbers Fun",
    image: img2,
    color: "#F58220",
    points: [
      "Counting",
      "Patterns",
      "Puzzles",
      "Measurement",
      "Logical Thinking",
    ],
    description:
      "A stimulating environment where children discover early mathematics through games, puzzles and logical activities.",
  },
  {
    id: 3,
    logo,
    title: "Language & Literacy Den",
    subtitle: "Where Communication Begins",
    image: img3,
    color: "#FDB913",
    points: ["Listening", "Phonics", "Vocabulary", "Reading", "Early Writing"],
    description:
      "Nurturing language development, phonics, vocabulary, storytelling, reading and early writing in a fun and engaging space.",
  },
  {
    id: 4,
    logo,
    title: "Cosmic Science Lab",
    subtitle: "Exploring the World Through Discovery",
    image: img4,
    color: "#67B32E",
    points: [
      "Curiosity",
      "Exploration",
      "Observation",
      "Experiments",
      "Problem Solving",
    ],
    description:
      "Encouraging young scientists to explore nature, science and the world around them through hands-on discovery and investigation.",
  },
];
